import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackGoogleAnalyticsPageView, isPublicPage } from '../lib/googleAnalytics'

/**
 * Hook to track Google Analytics page views on public pages
 * Automatically tracks page_view when route changes on public pages
 */
export const useGoogleAnalytics = () => {
  const location = useLocation()

  useEffect(() => {
    // Only track on public pages
    if (isPublicPage(location.pathname)) {
      // Small delay to ensure Google Analytics is loaded
      const timer = setTimeout(() => {
        trackGoogleAnalyticsPageView(location.pathname)
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [location.pathname])
}
